import React from "react";
import PropTypes from "prop-types";
import ProductImageContainer from "../ProductImageContainer";
import Image from "../Image";

const ProductImage = ({ badgeType, ...rest }) => (
  <ProductImageContainer badgeType={badgeType}>
    <Image {...rest} />
  </ProductImageContainer>
);

ProductImage.propTypes = {
  badgeType: PropTypes.oneOf(["MixMatch", "MoreColors"])
};

export default ProductImage;
